<div mat-dialog-title>
	<div class="d-flex justify-content-between">
		Workflow Action 
		<i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
	</div>
</div>

<div mat-dialog-content>
	<div class="row reset-row">
			<EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
				(OnClick)='setCartParams()'>
			</EIPGeneralCart>
	</div>
</div>